import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { config } from './config.ts';
import './index.css';

async function bootstrap(): Promise<void> {
  if (config.useMocks) {
    const [{ startMockWorker }, { setMockTiming }] = await Promise.all([
      import('./mocks/browser.ts'),
      import('./mocks/timing.ts'),
    ]);
    const speed = new URLSearchParams(window.location.search).get('mockSpeed');
    if (speed !== null && /^\d+(\.\d+)?$/.test(speed)) setMockTiming(Number(speed));
    await startMockWorker();
  } else if ('serviceWorker' in navigator && import.meta.env.PROD) {
    // PWA: el worker propio solo sin MSW (ambos usarían el mismo alcance "/").
    void navigator.serviceWorker.register('/sw.js');
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Falta #root');
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
